/// <reference path="pages-main.js"/>
/// <reference path="pages.js"/>

function CreateSubTaskFromListActions(obj, el) {
  obj['tr'] = $(el).parents('#' + obj.id);
  CreateSubTaskFromContextMenu(obj);
}

function CreateSubTaskFromContextMenu(parent) {
  var newCard;
  var OnError = function (error) {
    newCard.close();
    ShowError(error, null, 400);
  };

  function DoIt(decryptedKey) {
    var newTaskID;
    var serviceName;
    var serviceParams;
    //Создаём подзадачу

    if (parent.kind == "task") {
      serviceName = 'Task.asmx';
      serviceParams = { TaskID: parent.id, EncryptionKey: decryptedKey };
    } else {
      serviceName = 'Job.asmx';
      serviceParams = { JobID: parent.id, EncryptionKey: decryptedKey };
    }

    CallService(serviceName + '/CreateSubTask', serviceParams,
      function (res) {
        if (!res.Success) OnError(res.Error);
        else {
          newTaskID = res.Result;
          if (!!newTaskID) {
            parent.id = newTaskID;
            parent.kind = "task";
            var params = "mode=edit";
            newCard.location = GetObjectCardUrl(parent, params);
            newCard.focus();
          }
        }
      },
      OnError);
  }

  var encoding = parent.tr.attr('encoding');
  var pleaseWait = new WA.URL('/PleaseWait.aspx');
  pleaseWait.setParam('message', L('PLEASE_WAIT_TASK'));

  if (encoding > 0) {
    // Не поддерживаем работу с зашифрованными объектами.
    (new WA.CMP.dialogs.MessageBox()).showWarning(L('ERR_ENCODED_OBJECT_ARE_NOT_SUPPORTED'));

    Core.agent.getPlugin('edmsplugin').done(function (plugin) {
      var pluginName = parent.tr.attr('encpluginname');
      switch (encoding) {
        case '1':
          newCard = pleaseWait.open(parent.kind + parent.id);
          if (parent.kind == 'task') {
            WebAccess.agent.edms.getTaskDecryptedKey(parent.id, encoding, pluginName, "", DoIt, OnError);
          } else {
            WebAccess.agent.edms.getJobDecryptedKey(parent.id, encoding, pluginName, "", DoIt, OnError);
          }
          break;
        case '2':
        case '3':
          RequestPasswordForDecryption('',
            function (password) {
              newCard = pleaseWait.open(parent.kind + parent.id);
              if (parent.kind == 'task') {
                WebAccess.agent.edms.getTaskDecryptedKey(parent.id, encoding, pluginName, password, DoIt, OnError);
              } else {
                WebAccess.agent.edms.getJobDecryptedKey(parent.id, encoding, pluginName, password, DoIt, OnError);
              }
            });
          break;
      }
    });
  } else {
    newCard = pleaseWait.open('sub' + parent.kind + parent.id);

    //IOS замораживает вкладки, которые висят в фоне, поэтому к сожалению фабрики и асинхронные запросы в нем отдыхают
    if (WA.ENV.os.name.toLowerCase() === 'ios') {
      var folderId = WA.CR.getID() || OutboxFolderID;
      var page = (parent.kind == 'task' ? 'Task' : 'Job');
      var pageUrl = (new WA.URL('/' + page + '.aspx'));
      if (parent.kind == 'task') {
        pageUrl.setParam('mode', 'newsubtask');
      } else {
        pageUrl.setParam('op', 'newsubtask');
      }
      pageUrl.setParam('id', parent.id).setParam('folder', folderId).openIn(newCard);
      return;
    }

    DoIt(null);
  }
}


// Показывает запрашиваемые параметры для ззу.
// id - id задачи или задания.
// type - "job" или "task".
function ShowAskableParams(id, type, block = null) {
  id = id || GetParamInURL('id');
  type = type || (/job\.aspx/i.test(location.pathname) ? 'job' : 'task');
  ShowModalWindow("askable_params", {
    title: L("CUSTOMWORK_ASKABLE_PARAMS"),
    ok: () => {
      const jModalWindow = $('#modal_window');
      jModalWindow.data('success', () => {
        jModalWindow.data('ok', true);
        jModalWindow.dialog('close');
        if (WA.CR.Type === OBJECT_TYPE.JOB) {
          Core.jobs.performJob(id, block)
        } else {
          WA.CR.openReactTab(TAB_TYPE.TASK_CARD, true);
        }
      });
      jModalWindow.find('form').submit();
      return false;
    },
    close: () => {
      const modal = $('#modal_window');
      if (WA.CR.Type === OBJECT_TYPE.TASK) {
        if (!modal.data('ok')) {
          WA.SRV.request('/Task.asmx/SetStandardRoute', {
            TaskID: id,
            StandardRouteID: 0,
          }).done(() => {
            modal.dialog('close');
            WA.CR.openReactTab(TAB_TYPE.TASK_CARD, true);
          });
        }
      }
    },
    params: { WorkID: id, WorkType: type, WorkflowBlock: block },
    height: "auto",
    width: 700,
    afterOpen() {
      setTimeout(() => {
        //иначе форма не растягивается при ListRequisite
        $('#modal_window').css('height', 'auto');
        //вызов события после показа окна с запрашиваемыми параметрами
        if (type === 'job') {
          WebAccess.Job.fire('AfterShow');
        }
        if (type === 'task') {
          WebAccess.Task.fire('AfterShow');
        }

        const currentDialog = $('.ui-dialog');

        // Установкаа запрашиваемых параметров по
        currentDialog.keydown(event => {
          if (event.keyCode === 13) {
            const jTarget = $(event.target);

            // Проверка на справочник
            if (jTarget.tagName !== 'textarea' && !jTarget.closest('.reference_requisite, .Req_Pick').length) {
              this.ok();
            }
          }
        });

        // при перетаскивании диалога слетает высота и кнопки ОК/Отмена также могут уходить за границы видимой области
        currentDialog.on('dragstop', () => {
          currentDialog.css('height', 'auto');
        });
      }, 50);
    }
  });
  $('#modal_window').css('overflow', 'auto');
}

function ClearOpAfterError() {
  var id = GetParamInURL('id');
  CallService("/Task.asmx/SetStandardRoute", { TaskID: id, StandardRouteID: 0 }, function () {
    $('#modal_window').dialog('close');
    DoAction("-op")
  });
}

function ShowErrorOnAskableParams(text) {
  ShowMessage(text, L("CUSTOMWORK_ASKABLE_PARAMS"), ClearOpAfterError, null, null, null, true);
}

// Показывает окно выбора типового маршрута.
function ChangeStandartRoute() {
  ShowModalWindow('standard_route', {
    title: L('STANDARD_ROUTE'),
    ok: () => {
      const jModalWindow = $('#modal_window');
      const routeId = jModalWindow.find('#hSelID_route').val();
      SetStandardRoute(WA.CR.ID, routeId, null, (errMessage) => {
        jModalWindow.data('error')(errMessage);
      });
      return false;
    },
    params: {
      TaskID: WA.CR.ID,
    }
  });
}

function SetStandardRoute(TaskID, StandardRouteID, OnSuccess, OnError) {
  getStandardRouteCodeByID(StandardRouteID, function (data) {
    var standardRouteCode;
    var setStandardRouteCallback = function () {
      CallService("/Task.asmx/SetStandardRoute", { TaskID: TaskID, StandardRouteID: StandardRouteID }, function (res) {
        if (res.Success) {
          if (OnSuccess) {
            var r = OnSuccess();
            if (r === false) {
              return;
            }
          }
          if (res.Result) {
            ShowAskableParams(TaskID, 'task');
          } else {
            DoAction("op=ChangeRoute");
          }
          if (OnSuccess) OnSuccess();
        } else {
          if (OnError) {
            OnError(res.Error);
          }
        }
      });
    };

    // если запрос выполнился успешно и вернул только одну запись (если больше, то что-то явно не то - по одному ИД может быть только одна запись).
    // третье условие - что венрнулся только Код записи.
    if (data.Success && data.Result.length == 1 && data.Result[0].Requisites.length == 1) {
      standardRouteCode = $.trim(data.Result[0].Requisites[0].Value);
    }

    // Если для ТМа с кодом standardRouteCode есть означенные события, то выполним событие "До запроса параметров".
    if (typeof WebAccess.Events[standardRouteCode] != 'undefined') {
      WebAccess.Task.fireAll("Select", setStandardRouteCallback, standardRouteCode);
    } else {
      setStandardRouteCallback();
    }
  }, function () {
    ClearOpAfterError();
  });
}

function ShowWarningForTaskRouteException(msg) {
  var _showWarningFunc = function (callback) {
    ShowMessage(msg, L('WARNING'), null, L('OK'), 600, callback, false);
  };
  var _isModalShown = IsModalShown();

  HideTopSpinner('', 0, null, _isModalShown);
  setTimeout(function () {
    if (_isModalShown) {
      // Отключаем горячие главищи вообще, что бы Enter на кнопке ОК в окне ошибки сработал нормально. Для этого же и setTimeout
      key.setScope('');
      _showWarningFunc(function () {
        key.setScope('modalwindow');
      });
    } else {
      _showWarningFunc();
    }
  }, 100);
}

// Получает выбранные элементы (либо в диалоге, если он показан, либо в выборе из справочника).
function GetRouteSelectedItemsCount() {
  var inps = [$("#CardContrrolRoute"), $('#CardContrrolObservers')];
  var count = 0;
  for (var i = 0; i < inps.length; i++) {
    var inp = inps[i];
    var ms = inp.data('MultiSelectModalWindowInstance');
    if (ms && ms.isModalShown()) {
      count += ms.dataObject.selectedItems.length;
    } else if (inp.length > 0) {
      const referenceSelectInstance = inp.data('ReferenceSelectInstance');
      if (referenceSelectInstance) {
        count += referenceSelectInstance.getValues().length;
      }
    }
  }
  return count;
}

// Событие после смены маршрута с множественным выбором.
function TaskRouteChanged(inp, data, UsersRefName, UserGroupsRefName, StandardRoutesRefName, RouteLastObjectsRefName, isInModal) {
  var selItem;
  var isNeedToAddLastObject = true;
  if (!data || data.length == 0)
    return;

  if (!$.isPlainObject(data[0])) {
    // Данные выбраны через стандартное выпадающее меню.
    var id = data[0];
    var idParts = id.split(':');
    var refCode = '';
    if (idParts.length == 2) {
      refCode = idParts[0];
      id = idParts[1];
    } else {
      refCode = UsersRefName;
    };
    selItem = { groupcode: refCode, id: id, name: data[2] };
  } else {
    // Данные выбраны через модальное окно.
    selItem = data[0];
    // После нажатии на кнопку ОК уже не добавляем в последние объекты, т.к. уже были добавлены при переносе в правую часть.
    isNeedToAddLastObject = !!isInModal;
  };

  // Сохраним элемент для замены, т.к. возможно мы его изменим ниже.
  var itemToReplace = { groupcode: selItem.groupcode, id: selItem.id, name: selItem.name };

  // Если это псевдосправочник "Последние объекты в маршруте", то получим настоящий справочник и ИД выбираемой записи.
  if (selItem.groupcode === RouteLastObjectsRefName) {
    var idParts = selItem.id.split("_");
    if (idParts.length == 2) {
      selItem.groupcode = idParts[0];
      selItem.id = idParts[1];
    };
  };

  // Функция TaskRouteChanged срабатывает при нажатии на кнопку "ОК" в модальном диалоге, в этом случае, добавлять последние объекты не нужно,
  // т.к. они уже были добавлены при переносе в правую часть.
  // Добавляем к последним объектам, только корректные объекты.
  if (isNeedToAddLastObject && selItem.id > 0) {
    WA.SRV.session.addLastUsedObject(selItem.groupcode, selItem.id, selItem.name);
  }

  switch (selItem.groupcode) {
    case UsersRefName:
      //Текущее кол-во элементов поля
      if (typeof MAX_ROUTE_PARTICIPANT_COUNT !== 'undefined' && MAX_ROUTE_PARTICIPANT_COUNT !== null) {
        var CurrentUsersCount = GetRouteSelectedItemsCount();
        if (CurrentUsersCount > MAX_ROUTE_PARTICIPANT_COUNT) {
          inp.ReplaceLastSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, []);
          ShowWarningForTaskRouteException(L("TO_MANY_ITEMS"));
        } else {
          if (!IsModalShown()) {
            WA.CMP.NTF.InlineHint.hideAll();
          }
        };
      }

      //Если выбрали из RouteLastObjectsRefName, то заменяем на обычного пользователя.
      if (itemToReplace.groupcode === RouteLastObjectsRefName) {
        inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, [[UsersRefName + ':' + selItem.id, selItem.name, selItem.name]]);
      }

      break;
    case UserGroupsRefName:
      ExpandUsersGroup(inp, selItem, UserGroupsRefName, UsersRefName, itemToReplace);
      break;
    case StandardRoutesRefName:
      UnbindBeforeUnload();
      inp.SetDisabled();
      $('#CardContrrolObservers').SetDisabled();
      SetStandardRoute(GetParamInURL('id'), selItem.id, null, function (msg) {
        // покажем сообщение об ошибке
        WA.CR.inlineHint.showError(msg, null, INLINE_HINT_PRIORITY.PRIMARY);        
        // и почистим ReferenceSelect.
        inp.Clear();
        inp.SetEnabled();
        $('#CardContrrolObservers').SetEnabled();
      });
      break;
  };
}

function ExpandUsersGroup(inp, item, UserGroupsRefName, UsersRefName, itemToReplace) {
  if (item.groupcode == UserGroupsRefName) {
    ShowTopSpinner(L("GROUP_EXPANDS"), false, true);

    var replaceGroup = function (NeedProcessSubGroups) {
      // Получим всех пользователей в группе.
      CallService("/UserList.asmx/GetUsersInGroup", { GroupID: item.id, NeedProcessSubGroups: NeedProcessSubGroups, RenderItems: false }, function (res) {
        if (res.Success) {
          var newValues = [];
          //Текущее кол-во элементов поля
          var CurrentUsersCount = GetRouteSelectedItemsCount() - 1; // -1 без вставленной группы

          if (MAX_ROUTE_PARTICIPANT_COUNT == null || (CurrentUsersCount + res.Result.length) <= MAX_ROUTE_PARTICIPANT_COUNT) {
            if (!IsModalShown()) {
              WA.CMP.NTF.InlineHint.hideAll();
            }

            $.each(res.Result, function () {
              newValues.push([UsersRefName + ':' + this.id, ('' + this.text).escapeHtml(), this.text]);
            });

            //Переинициализируем компоненту.
            inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, newValues);

            if (newValues.length > 0) {
              HideTopSpinner(L("GROUP_EXPANDED"), 3000, null, true);
            } else {
              HideTopSpinner(L("EMPTY_GROUP_WASNT_EXPANDED"), 3000, null, true);
            }
          } else {
            inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, []);
            ShowWarningForTaskRouteException(L("TO_MANY_ITEMS"));
          }
        } else {
          inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, []);
          ShowWarningForTaskRouteException(res.Error);
        };
      });
    };

    CallService("/UserList.asmx/HasGroupUsersAndSubGroups", { GroupID: item.id }, function (res) {
      if (res.Success) {
        // Если ли в группе и пользователи, и группы одновременно?
        if (res.Result) {
          var isButtonClicked = false;
          // Выдаем предложение что будем добавлять - пользователй группы или пользователей всех её подгрупп.
          var yesBtn = function () {
            isButtonClicked = true;
            replaceGroup(true);
          };
          var sett = {
            text: format(L('DO_YOU_ALSO_WANT_TO_ADD_USERS_FROM_SUBGROUPS_OF_GROUP'), { 'groupName': item.name }),
            close: function () {
              if (!isButtonClicked) {
                replaceGroup(false);
              }
              HideTopSpinner('', 3000, null, true);
              key.setScope('modalwindow');
            }
          };
          setTimeout(function () {
            // Отключаем горячие главищи вообще, что бы Enter на кнопке ОК в окне ошибки сработал нормально. Для этого же и setTimeout
            key.setScope('');
            ConfirmDialogNew(sett, yesBtn, function () { });
          }, 100);
        } else {
          // Добавляем всех пользователей всех подгрупп.
          replaceGroup(true);
        };
      };
    });
  }
}

function InitTaskRouteModalWindowsOpts(inp, UsersRefName, UserGroupsRefName, StandardRoutesRefName, customPlaceHolder, RouteLastObjectsRefName) {
  return {
    excludeGroups: [StandardRoutesRefName, RouteLastObjectsRefName],
    treeMode: true,
    customPlaceholder: customPlaceHolder,
    events: {
      'OnAfterOpen': function () {
        var inpId = inp.attr('id');
        if (inpId == 'CardContrrolRoute') {
          BindHelpIcoClickOnModalWindow('RouteSetup');
        } else {
          BindHelpIcoClickOnModalWindow('ObserversSetup');
        };
      },
      'OnSelectedItem': function (eventName, item) {
        TaskRouteChanged(inp, [item], UsersRefName, UserGroupsRefName, StandardRoutesRefName, RouteLastObjectsRefName, true);
      }
    }
  };
}

function ShowRouteModalWindowAfterLoad() {
  $(function () {
    setTimeout(function () {
      $("#CardContrrolRoute").ShowMultiSelectModalWindow();
    }, 100);
  });
};

// Навешиват кнопку удаления последних объектов.
function BindRemoveLastObjectBtn(RouteLastObjectsRefName, jControl) {
  var touchDev = $.ipad || WA.ENV.isAndroid();

  jControl.on('OnRowsCreated', function (ev, refCode, rows) {
    if (refCode && refCode.toLowerCase() === RouteLastObjectsRefName.toLowerCase()) {
      $.each(rows, function () {
        var row = $(this);
        if (!row.hasClass('removeLastObjBtnInit')) {
          var rowIco = row.find('.rs_ico');
          // Пропускаем Избранных, их нельзя удалять.
          if (!rowIco.hasClass('FavoriteUser_16.png') && !rowIco.hasClass('FavoriteUserGroup_16.png')) {
            var delBtn = $('<p class="deleteLastObj sprite_ico ' + (touchDev ? '' : 'vishidden') + '">' +
              '<svg class="refselect-input__delete-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-delete-16"></use></svg>' +
              '</p>');
            delBtn.on('click', function (ev) {
              ev.stopPropagation();
              ev.preventDefault();

              //Получаем набор данных; берем ИД [0]; для этого справочника ИД сложный, поэтому берем настоящий ИД [1]. Сложнный ИД в формате "КОДСПР_ИД"
              var id = row.attr('DataRow').split('|')[0].split('_')[1];
              WA.SRV.session.removeLastUsedObject(id);
              // Удаляем сразу, что бы не ждать завершения запроса и пользователь сразу увидел результат своего действия.
              row.remove();

              return false;
            });
            row.find('.rs_td').prepend(delBtn);

            // Показываем кнопку удаления при наведении только для обычных PC.
            if (!touchDev) {
              row.on('mouseenter.removeLastObj', function () {
                $(this).find('.deleteLastObj').removeClass('vishidden');
              }).on('mouseleave.removeLastObj', function () {
                $(this).find('.deleteLastObj').addClass('vishidden');
              });
            };
          };

          row.addClass('removeLastObjBtnInit');
        };
      });
    }
  });
}



(function (global) {

  const getSuitableCertificates = function () {
    return WA.SRV.request('/Certificates.asmx/GetSuitableCertificate', {},{
      hideSpinner: true,
      hideError:true});
  };

  // Отправляет запрос к агенту для подписания.
  let signingCustomWorkIds = [];
  const _sendSignDataToAgent = (type, id, pluginName, pluginVersion, certId, afterSignCallback, tokenPinCode) => {
    if (type === 'T') {
      WebAccess.agent.edms.signTask(
        id,
        certId,
        pluginName,
        null,
        null,
        null,
        null,
        afterSignCallback,
        pluginVersion,
        tokenPinCode);
    }
    if (type === 'J') {
      WebAccess.agent.edms.signJob(
        id,
        certId,
        pluginName,
        null,
        null,
        null,
        null,
        afterSignCallback,
        pluginVersion,
        tokenPinCode);
    }
  };

  const getErrorWithCustomWorkName = function (error, name, type, id) {
    if (!error) {
      //Сюда может зайти например если вынули токен при подписании и нажали Отмена в окне с токеном
      error = L('CERTIFICATE_FOR_SIGNING_OBJECT_IS_NOT_SPECIFIED_OR_SPECIFIED_INCORRECTLY');
    }
    if (name) {
      let information = L((type === 'T' ? 'TASK' : 'JOB'));
      let objectType = L((type === 'T' ? OBJECT_TYPE.TASK : OBJECT_TYPE.JOB));
      let objectLink = (new WA.Link(id, objectType)).toURL().asString();

      return `<li> ${information} "<a href="${objectLink}" target="_blank">${name}</a>": ${error}</li>`;
    } else {
      return `<li> ${error}</li>`;
    }
  };

  /**
   * Подписание ЗЗУ.
   *
   * @function SignCustomWork
   * @param {OBJECT_TYPE} type Тип.
   * @param {number} id ИД ЗЗУ.
   * @param {string} name Наименование.
   * @param {boolean} [opt_silent = false] True - подписание без уведомлений.
   * @return {Deferred<void>}
   * @see https://api.jquery.com/category/deferred-object/
   */
  const SignCustomWork = function (type, id, name, opt_silent) {
    var result = $.Deferred();

    if (name) {
      name = ('' + name).escapeHtml();
    }

    Core.agent.getPlugin('edmsplugin').done(plugin => {
      getSuitableCertificates().done((res, resp) => {
        const certificate = res;
        const certArr = certificate.split('###');
        models.User._current.DefaultCertificate = {
          PluginName: certArr[0],
          CertificateID: certArr[1],
          PluginVersion: certArr[2],
          IsValid: !resp.Warning,
        };

        const cert = models.User._current.DefaultCertificate;
        if (!cert.IsValid) {
          if (!opt_silent) {
            ShowError((resp.Warning || '').fromISBuilderToNormal());
          }
          result.reject(
            getErrorWithCustomWorkName((resp.Warning || '').fromISBuilderToNormal(),
            name,
            type,
            id));
          return;
        }

        // Подписание ЗЗУ.
        const onSignCallback = function (res) {
          if (res.success) {
            const successMessageCode = (type === 'T' ? 'TASK_SIGN_SUCCESS' : 'JOB_SIGN_SUCCESS');
            if (!opt_silent) {
              ShowTopSpinnerResult(L(successMessageCode), 3000);
            }
            result.resolve();
          } else {
            if (!!res.message && (res.result === 'ERR_PIN_REQUIRED')) {
              const jTokenPinCode = $("#task_token_pin_code");
              // Так мы определим, что у нас происходит массовое совместное подписание документов и ЗЗУ
              const jDocsTokenPinCode = $("#modal_window").find(".token_pin_code");

              if (signingCustomWorkIds.indexOf(id) === -1) {
                signingCustomWorkIds.push(id);
              }

              if (jTokenPinCode.length === 0) {
                // Проверка массового совместном подписании документов и ЗЗУ
                if (jDocsTokenPinCode.length !== 0)
                {
                  if (jDocsTokenPinCode.val() !== '') {
                    
                    for (const customworkElement of signingCustomWorkIds) {
                      _sendSignDataToAgent(
                        type,
                        customworkElement,
                        cert.PluginName,
                        cert.PluginVersion,
                        cert.CertificateID,
                        onSignCallback,
                        jDocsTokenPinCode.val());
                    }
                  }

                  return;
                }

                const formBuilder = new WA.CMP.forms.FormBuilder('taskjobpincode');
                const tokenPinCodeId = 'TASK_TOKEN_PIN_CODE';
                formBuilder.addInput(tokenPinCodeId, null, null, 'password');

                const dialog = new WA.CMP.dialogs.BaseDialog();
                dialog.title = L("PIN_CODE_ASK");
                dialog.setHtml(formBuilder.render());

                dialog.isShowCancelButton = true;
                dialog.ok = function() {
                  const pinCodeValue = formBuilder.getValue(tokenPinCodeId);
                  dialog.close();
                  for (const customworkElement of signingCustomWorkIds) {
                    _sendSignDataToAgent(
                      type,
                      customworkElement,
                      cert.PluginName,
                      cert.PluginVersion,
                      cert.CertificateID,
                      onSignCallback,
                      pinCodeValue);
                  }
                };
                dialog.show();
              }
              return;
            }

            if (!!res && !opt_silent) {
              if (res.message) {
                ShowError(res.message);
              } else {
                //Сюда может зайти например если вынули токен при подписании и нажали Отмена в окне с токеном
                ShowError(L('CERTIFICATE_FOR_SIGNING_OBJECT_IS_NOT_SPECIFIED_OR_SPECIFIED_INCORRECTLY'));
              }
            }
            result.reject(getErrorWithCustomWorkName(res.message.fromISBuilderToNormal(), name, type, id));
            //Почистить запись в профиле
            WA.cache.serverCache.setItem('CertificateIDForCustomworkSign', '');
          }
        };
        _sendSignDataToAgent(
          type,
          id,
          cert.PluginName,
          cert.PluginVersion,
          cert.CertificateID,
          onSignCallback,
          null);
      }).fail(errMsg => {
        //показать диалог если не удалось получить подходящий сертификат
        SignEDoc(id, null, true, type);
      });
    }).fail(() => {
      const err = L("ERR_SIGNING_UNSUPPORTED");
      if (!opt_silent) {
        ShowError(err);
      }
      //Почистить запись в профиле
      WA.cache.serverCache.setItem('CertificateIDForCustomworkSign', '');
      result.reject(getErrorWithCustomWorkName(err.fromISBuilderToNormal(), name, type, id));
    });
    return result;
  };

  global.SignTask = function (id, name, opt_silent) {
    return SignCustomWork('T', id, name, opt_silent);
  };
  global.SignJob = function (id, name, opt_silent) {
    return SignCustomWork('J', id, name, opt_silent);
  };


  var GetEncryptedCustomWorkTree = function (type, id, encodingType, pluginName) {
    Core.agent.getPlugin('edmsplugin').done(function (plugin) {
      //Получает ключ для расшифровки текста делового процесса
      var GetDecryptedKey = function (additionalParams) {
        ShowTopSpinner(L("PLEASE_WAIT"), true);

        //Запрашиваем токен на расшифровку текста делового процесса
        RequestToken(TOKEN_OPERATION.GET_ENCRYPTION_KEY, function (token) {
          var requestName = (type == 'T' ? "GetTaskDecryptedKey" : "GetJobDecryptedKey");

          //Заполняем параметры запроса
          var params = { "EncodeType": encodingType, "EncryptionPluginName": pluginName, "Token": token };
          if (!!additionalParams) $.extend(params, additionalParams);
          if (type == 'T') {
            params["TaskID"] = id;
          } else {
            params["JobID"] = id;
          }

          WebAccess.agent.transmitRequest(requestName, "edmsplugin", params).done(function (response) {
            //Получаем текст делового процесса
            if (type == 'T') {
              CallService("Task.asmx/GetWorkTreeHtml", { TaskID: id, EncryptionKey: response.result }, function (response) {
                if (response.Success) {
                  if ($('.ListRequisiteList[kind=att]').length > 0) {
                    $('span.MainText').append(response.Result);
                    $('.TaskTree').removeClass('TaskTree__hidden');
                    $('#Attachments_AttachmentsList_list').removeClass('content-list__area_hidden');
                  } else {
                    window.location.reload();
                  }
                } else {
                  $('span.MainText').append(response.Error);
                }
              });
            } else {
              CallService("Job.asmx/GetWorkTreeHtml", { JobID: id, EncryptionKey: response.result }, function (response) {
                if (response.Success) {
                  if ($('.ListRequisiteList[kind=att]').length > 0) {
                    $('span.MainText').append(response.Result);
                    $('.TaskTree').removeClass('TaskTree__hidden');
                    $('#Attachments_AttachmentsList_list').removeClass('content-list__area_hidden');
                  } else {
                    window.location.reload();
                  }
                } else {
                  $('span.MainText').append(response.Error);
                }
              });
            }
          }).fail(function (response) {
            try {
              //FIXME: нужен ли декодинг?
              //resultMessage = decodeURIComponent(response.message);
              resultMessage = response.message;
            } catch (e) {
              resultMessage = L('CUSTOMWORK_DECODING_FAIL');
            }
            ShowError(resultMessage, function () {
              if (encodingType % 2 === 1) {
                CloseWindow();
              } else {
                GetEncryptedCustomWorkTree(type, id, encodingType, pluginName);
              }
            },
            400,
            function () {
              CloseWindow();
            });
          }).always(function (response) {
            HideTopSpinner("", 1);
          });
        }, id);
      };

      //Если в шифровании используется пароль, то запросим его у пользователя.
      if (encodingType >= 2) {
        return RequestPasswordForDecryption(null,
          function (pass) { GetDecryptedKey({ Password: pass }); },
          function () {
            if (!!!$("#docPassword").data('entered')) {
              CloseWindow();
            }
          }).cancel = function () {
            CloseWindow();
          };
      } else {
        GetDecryptedKey(null);
      }
    });
  };

  global.GetEncryptedTaskTree = function (id, encoding, pluginName) {
    return GetEncryptedCustomWorkTree('T', id, !!encoding ? encoding : WebAccess.current.Encoding, !!pluginName ? pluginName : WebAccess.current.PluginName);
  };

  global.GetEncryptedJobTree = function (id, encoding, pluginName) {
    return GetEncryptedCustomWorkTree('J', id, !!encoding ? encoding : WebAccess.current.Encoding, !!pluginName ? pluginName : WebAccess.current.PluginName);
  };

})(window);

function ShowEncodedObjectError(error) {
  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox.width = 470;
  mbox.showError(error, null, null, function () { WA.CR.window.close(); });
}

var clamp = function (val, min, max) {
  return Math.min(Math.max(val, min), max);
};

// Инициализирует возможность изменять размер панели вложений.
function InitAttachmentsResize() {
  var minX = 850;
  var defaultAttachWidth = 260;

  function setWidth(w) {
    w = parseInt(w, 10);
    var jMainContainer = $('#main_container');
    var attd = jMainContainer.find('.attachments_td');
    attd.width(w);

    var jCard = jMainContainer.find(".card:first");
    jCard.css({ "marginRight": w });
    var jLeftColumn = $('#left_column');
    if (jLeftColumn.hasClass('horizontal')) {
      jLeftColumn.css({ "marginRight": w});
    }

    var lr = ListRequisite(attd.find('.ListRequisite').attr('id'));
    if (lr.onUpdate) lr.onUpdate();

    // установка размеров реактивной карточки
    const jCardTabContainer = $('.card-tab-container');
    jCardTabContainer.find('.card-tab-container__main').css({ 'maxWidth': `calc(100% - ${w}px)` });
    jCardTabContainer.find('.card-tab-container__aside').css({ 'minWidth': w });
    $(window).trigger('resize');
  }

  var res = $.cookie('attwidth');
  if (!!res) {
    setWidth(res);
  } else {
    setWidth(defaultAttachWidth);
  }

  $('#attachments_dragarea').mousedown(function (ev) {
    ev.preventDefault();
    var $this = $(this);
    var maxX = $(window).width() - defaultAttachWidth;
    $this.addClass('dragging').offset({ left: clamp(ev.pageX, minX, maxX) });
    $('html').css('cursor', 'col-resize')
    .bind('mousemove.attresize', function (ev) {
      ev.preventDefault();
      $this.offset({ left: clamp(ev.pageX, minX, maxX) });
    })
    .bind('mouseup.attresize', function (ev) {
      ev.preventDefault();
      $('html').css('cursor', '').unbind('mousemove.attresize').unbind('mouseup.attresize');
      $this.removeClass('dragging').css('left', '');
      var w = $(window).width() - clamp(ev.pageX, minX, maxX) + 10;
      setWidth(w);
      document.cookie = "attwidth=" + w;
    });
  });
}

function InitSavedTextResize() {
  if (![OBJECT_TYPE.TASK, OBJECT_TYPE.JOB].includes(WA.CR.Type)) {
    return;
  }
  // проверяем, есть ли вообще видимая область переписки
  if (!$('.bottom_textarea:visible').innerHeight()) {
    return;
  }

  let jConversation = $('.task-corresponds');
  if (!jConversation.length) {
    jConversation = $('.conversation-container__main');
  }
  let jSavedText = jConversation.find('.card_task_savedtext_container');
  if (!jSavedText.length) {
    jSavedText = jConversation.find('#ctl00');
  }
  if (jSavedText.length) {
    // Размеры элементов
    const dragAreaHeight = 12;
    const minTextAreaHeight = 140;

    const taskCorrespondsHeight = jConversation.height();
    const jTextArea = jConversation.find('.bottom_textarea');
    jSavedText.css({ height: taskCorrespondsHeight - jTextArea.height() - dragAreaHeight });

    if (!$.ipad) {
      jSavedText.resizable({
        handles: {
          s: jSavedText.next()
        },
        helper: 'ui-resizable-helper',
        stop: (event, element) => {
          let textAreaHeight = Math.max(taskCorrespondsHeight - element.size.height, minTextAreaHeight);
          jTextArea.css({ minHeight: textAreaHeight });
          jSavedText.css({ width: 'auto', height: taskCorrespondsHeight - textAreaHeight - dragAreaHeight });
        },
      });
    }
  }
}

// Отображение в раскрытом виде только тех подзадач, которые относятся к текущему заданию.
function ShowOnlyCurrentRelatedTasks() {
  var jTreeElements = $('.TaskTree').find('[id*="Item_"]');
  // Скрытие (схлопывание) подзадач, не содержащих текущее задание.
  jTreeElements.each(function() {
    if (!$(this).find('.ParentForCurrentItemHeader, .CurrentItemHeader').length) {
      var jArrow = $(this).find('.ItemExpandCollapse').get(0);
      ChangeItemExpandCollapse(jArrow);
    }
  });
  // Раскрытие всех потомков текущих элементов.
  var jChildrenOfCurrentElement = $('.CurrentItemHeader').eq(0).parents('div:first').children('div');
  var jExpandCollapseArrow = jChildrenOfCurrentElement.find('.ItemExpandCollapse');
  jExpandCollapseArrow.each(function() {
    if ($(this).hasClass('att_plus.png')) {
      ChangeItemExpandCollapse($(this));
    }
  });
  // Раскрытие всех заданий-потомков родителя текущего элемента.
  var jChildrenOfParentForCurrentElement = $('.ParentForCurrentItemHeader').eq(0).parents('div:first').children('div');
  jChildrenOfParentForCurrentElement.each(function() {
    if ($(this).hasClass('Item_Job')) {
      var jExpandCollapseArrow = $(this).find('.ItemExpandCollapse');
      jExpandCollapseArrow.each(function() {
        if ($(this).hasClass('att_plus.png')) {
          ChangeItemExpandCollapse($(this));
        }
      });
    }
  });
}

// Прокрутка до активного задания.
function ScrollTreeToCurrentJob() {
  const jRightColumn = $('#right_column');

  // Найдем контейнер переписки
  let jSavedText = jRightColumn.find('.card_task_savedtext_container');

  // ToDo: в заданиях кривая разметка, поэтому будем искать другой элемент.
  if (!jSavedText.length) {
    jSavedText = $('#ctl00');
  }

  if (jSavedText.length) {
    jSavedText.scrollTop(0);

    // Найдем текущую ЗЗУ
    const jCurrentCustomWork = jSavedText.find('.CurrentItemHeader,.CurrentItemMark:last').closest('table');

    if (jCurrentCustomWork.length) {

      // Получим расстояние до контейнера переписки
      const savedTextTop = jSavedText.offset().top;

      // Получим расстояние до текущей ЗЗУ
      const currentCustomWorkTop = jCurrentCustomWork.offset().top;

      // Проскролим до текущей ЗЗУ
      jSavedText.scrollTop(currentCustomWorkTop - savedTextTop);
    }
  }
}

/**
   * Диалог установки прав на вложения.
   * @function ShowTaskAttachmentsAssignRightDlg
   * @param {string} taskID ид объекта
   * @param {string} userRights права на вложения
   * @param {string} message сообщение
   * @param {string} isTask признак является ли задачей
   * @param {string} postbackAction действие postback
   * @param {string} resVar результат выполнения задания
   */
function ShowTaskAttachmentsAssignRightDlg(taskID, userRights, message, isTask, postbackAction, resVar) {
  //var title = 'What attachments rights assign to task participants?'
  //var msg = 'Some of the task participants do not have minimal necessary attachments rights (to view). Press View, Modify or Full to assign corresponding rights, Ignore if you don\'t want to change any rights and Cancel to abort task start.'
  function ProceedTaskStarting(attachmentsRights) {
    UnbindBeforeUnload();
    if (isTask) {
      CallService("/Task.asmx/SetAttachmentsRights", { TaskID: taskID, Rights: attachmentsRights }, function (res) {
        if (res.Success) {
          DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
        } else {
          ShowTaskAttachmentsAssignRightDlg(taskID, res.Result, res.Error, isTask);
        };
      });
    } else {
      CallService("/Job.asmx/SetAttachmentsRights", { JobID: taskID, Rights: attachmentsRights }, function (res) {
        if (res.Success) {
          DoActionForJob(postbackAction, resVar);
        } else {
          ShowTaskAttachmentsAssignRightDlg(taskID, res.Result, res.Error, isTask);
        };
      });
    }
  }

  if (userRights == "Empty") {
    if (isTask) {
      DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
    } else {
      DoActionForJob(postbackAction, resVar);
    }
    return;
  }

  var mbox = new WA.CMP.dialogs.MessageBox();
  if (userRights == "Full") {
    mbox
     .addButton('view_right_btn', L('VIEWING'), function () { ProceedTaskStarting(ACCESS_RIGHTS.VIEW); })
     .addButton('modify_right_btn', L('MODIFY'), function () { ProceedTaskStarting(ACCESS_RIGHTS.CHANGE); })
     .addButton('full_right_btn', L('FULL'), function () { ProceedTaskStarting(ACCESS_RIGHTS.FULL); })
     .addButton('max_right_btn', L('MAXIMALLY_POSSIBLE_RIGHTS'), function () {
       if (isTask) {
         WA.services.call("/Task.asmx/SetMaximallyPossibleRightsOnAttachments", { TaskID: taskID }).success(function () {
           DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
         });
       } else {
         WA.services.call("/Job.asmx/SetMaximallyPossibleRightsOnAttachments", { JobID: taskID }).success(function () {
           DoActionForJob(postbackAction, resVar);
         });
       }
     })
     .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
     ._setDefaultButton('view_right_btn');
  }
  if (userRights == "View") {
    mbox
    .addButton('view_right_btn', L('VIEWING'), function () { ProceedTaskStarting(ACCESS_RIGHTS.VIEW); })
    .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
    ._setDefaultButton('view_right_btn');
  }
  if (userRights == "Change") {
    mbox
      .addButton('view_right_btn', L('VIEWING'), function () { ProceedTaskStarting(ACCESS_RIGHTS.VIEW); })
      .addButton('modify_right_btn', L('MODIFY'), function () { ProceedTaskStarting(ACCESS_RIGHTS.CHANGE); })
      .addButton('max_right_btn', L('MAXIMALLY_POSSIBLE_RIGHTS'), function () {
        if (isTask) {
          WA.services.call("/Task.asmx/SetMaximallyPossibleRightsOnAttachments", { TaskID: taskID }).success(function () {
            DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
          });
        } else {
          WA.services.call("/Job.asmx/SetMaximallyPossibleRightsOnAttachments", { JobID: taskID }).success(function () {
            DoActionForJob(postbackAction, resVar);
          });
        }
      })
      .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
      ._setDefaultButton('view_right_btn');
  }

  if (userRights == "NoAccess") {
    mbox
    .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
    ._setDefaultButton('ignore_button');
  }

  mbox.isShowCancelButton = true;
  mbox.isShowOkButton = false;
  var msg = L('WARN_ASSIGN_TASK_ATTACHMENTS_RIGHTS_DLG_MSG');

  if (typeof message != 'undefined') {
    msg = L('WRN_CANNOT_SET_ATTACHMENTS_RIGHTS') + '<br/>' + message;
  }

  mbox.showQuestion(L('WARN_ASSIGN_TASK_ATTACHMENTS_RIGHTS_DLG_CAPTION'), msg, L('ACCESS_RIGHTS'));
}

/**
   * Выполнить действие для заданий.
   * @function DoActionForJob
   * @param {string} postbackAction действие postback
   * @param {string} resVar результат выполнения задания
   */
function DoActionForJob(postbackAction, resVar) {
  if (postbackAction) {
    //В случае если по ТМ
    if (resVar > -1) {
      DoAction(format('__POSTBACK_ACTION={0}&IgnoreAttachmentsRights=true&__RESULT_VAR={1}', postbackAction, resVar), true);
    } else {
      DoAction(format('__POSTBACK_ACTION={0}&IgnoreAttachmentsRights=true', postbackAction), true);
    }
  } else {
    //если по свободному маршруту
    DoAction('op=doit&IgnoreAttachmentsRights=true', true);
  }
}

(function (global) {
  var encryptTaskWithCert = function (id) {
    var encryption = 1;

    var encryptCheckBox = $('#EncryptWithCertCheck');
    var rightType = $('input[id*=RightsType][type=text]');
    setTimeout(function () {
      if (encryption == 1) {
        encryptCheckBox.attr('checked', 'chedked').change();
        //rightType.data('DropDownListInstance').addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
      } else {
        encryptCheckBox.removeAttr('checked').change();
        //rightType.data('DropDownListInstance').removeDropDownListItem('M').setPrevValue().enable();
      }
    }, 100);
    $('#TaskEncryptionType').val(encryption);
  };

  var setEncryption = function (id, encryption, password, onSuccess, onFail) {
    WA.SRV.call('/Task.asmx/SetEncryption', { TaskID: id, Encryption: encryption, Password: password })
      .success(function (res) {
        HideTopSpinner('task enctypted!');
        if (!!onSuccess) onSuccess();
      })
      .fail(function (error) {
        if (!!onFail) onFail(error);
      });
  };

  global.EncryptTaskWithCert = function (id) {
    return encryptTaskWithCert(id);
  };
})(window);

function EncryptWithCertCheckbox(el) {
  var encryption = $(el).is(':checked') ? 1 : 0;
  var rightType = $('input[id*=RightsType][type=text]');
  var dropDownList = rightType.data('DropDownListInstance');
  if (encryption == 1) {    
    dropDownList.addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
    if (dropDownList.prevValue != 'M') $.cookie('lastAccessType', dropDownList.prevValue);
  } else {
    dropDownList.removeDropDownListItem('M');
    if (!!$.cookie('lastAccessType')) dropDownList.setValue($.cookie('lastAccessType')).enable();
    else dropDownList.setPrevValue().enable();
  }
  $('#TaskEncryptionType').val(encryption);
}

$(function () {
  WA.ready(function () {
    if (WA.getLocation() == 'task') {
        var rightType = $('input[id*=RightsType][type=text]');
        const dropDownList = rightType.data('DropDownListInstance');
        if ($('#TaskEncryptionType').val() == '1') {
         if ((rightType.length) && (!!dropDownList)) {
          dropDownList.addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
         }
         $('#EncryptWithCertCheck').attr('checked', true);
        } else {
         if (rightType.length && (WA.Task.ID == WA.Task.MainTaskID) && (!!dropDownList)) {
          dropDownList.removeDropDownListItem('M').setPrevValue().enable();
         }
         $('#EncryptWithCertCheck').removeAttr('checked');
        }
    }
  });
});

/**
 * Добавляет ссылку на объект во вложения.
 * @param {Link} link Ссылка на объект.
 * @since 5.1.0.1522
 */
function AddAttachment(link) {
  if (!!link) {
    var att = ListRequisite('Attachments_AttachmentsList');
    var linkModel = link.toLinkModel();
    // Проверяем если уже такая ссылка.
    if (att.CheckObject(linkModel)) {
      // Если нет, то добавляем.
      att.AddObject(linkModel);
      att.UpdateList();
    }
  }
};
